import React from 'react';
import { Countdown } from './Countdown';
import { PricingSection } from './PricingSection';
import { footerTrust } from '../data/content';

// 23:44:04
const START_SECONDS = 23 * 3600 + 44 * 60 + 4;
export function FinalCta() {
  return <>
      <section className="w-full bg-blood-900 px-4 py-7 text-center sm:px-6 sm:py-9" data-id="element-59" data-mp="19ga7dihqapvx">
        <div className="mx-auto max-w-2xl" data-id="element-60" data-mp="15bsnljbdccl5">
          <h2 className="text-sm font-extrabold uppercase tracking-wide text-white sm:text-lg" data-id="element-61" data-mp="1jd4z9ijhxs18">
            ⏰ El precio cierra en:
          </h2>

          <div className="mt-4" data-id="element-62" data-mp="1ed8yds63igpw">
            <Countdown startSeconds={START_SECONDS} data-id="element-63" data-mp="1ec7ldi5irk5j" />
          </div>

          <p className="mx-auto mt-4 max-w-xl text-[13px] leading-snug text-neutral-300 sm:text-base" data-id="element-64" data-mp="1t2ev99hgnuum">
            Con textos listos. Con planillas reales. Con protocolos para
            ejecutar hoy.
          </p>
        </div>
      </section>

      <PricingSection id="ofertas-final" compact data-id="element-65" data-mp="1x4jjfsp53z9v" />

      <ul className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 bg-ink-800 px-4 pb-10 text-[11px] text-neutral-400 sm:text-sm" data-id="element-66" data-mp="1x64gboyxfuaw">
        {footerTrust.map(item => <li key={item} data-id="element-67" data-mp="s5qr24f65kxw">{item}</li>)}
      </ul>
    </>;
}